<template>
  <v-card
    elevation="10"
    width="100%"
    :loading="isLoading"
  >
    <v-card-title>
      Meu Plano
      <v-spacer/>
    </v-card-title>
    <v-card-text>
      <v-skeleton-loader
        v-if="isLoading"
        :loading="isLoading"
        type="table"
        class="mx-auto flex-fill"
        width="100%"
      />
      <v-scale-transition>
        <v-data-table
          v-if="!isLoading"
          :headers="myPlanHeader"
          :items="myPlanData"
          disable-filtering
          disable-pagination
          disable-sort
          hide-default-footer
        >
          <template v-slot:header.flCredits="{ header }">
            {{ header.text }}
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon
                  small
                  v-on="on"
                  color="info"
                  class="ml-1 mb-2"
                >
                  mdi-alert-circle
                </v-icon>
              </template>
              <span>{{strCreditsDescription}}</span>
            </v-tooltip>
          </template>
          <template v-slot:item.flCredits="{ item }">
            <span class="blue--text text--darken-4">{{item.flCredits | toFixedWithComma}}</span>
          </template>
        </v-data-table>
      </v-scale-transition>
    </v-card-text>
  </v-card>
</template>

<script>
  import {getUserCredits, listUserHectarePackage} from "../../api/api-billing"
  import {includes} from "lodash/collection"
  import moment from "moment"

  export default {
    name: "MyPlan",
    data: () => ({
      isLoading: true,

      flUserCreditsConverted: 0
    }),
    filters: {
      toFixedWithComma(value) {
        return value.toFixed(2).replace(".", ",")
      }
    },
    computed: {
      chargeTypeIsCredits() {
        if (this.$subsMng.subscriptionPlan["str_charge_type_system"] == 'credits')
          return true
        return false
      },   
      myPlanHeader() {
        if (this.$subsMng.subscriptionPlan["str_charge_type_system"] == 'credits') {
          return [
            {
              text: "Plano",
              value: "strPlan",
            },
            {text: "Informação de cobrança", value: "strChargeInfo"},
            {text: "Método de pagamento", value: "strPaymentMethod"},
            {
              text: "Meus créditos",
              value: "flCredits",
            },
          ]
        } else {
          return [
            {
              text: "Plano",
              value: "strPlan",
            },
            {text: "Informação de cobrança", value: "strChargeInfo"},
            {text: "Método de pagamento", value: "strPaymentMethod"},
          ]          
        }
      },
      myPlanData() {
        return [
          {
            strPlan: this.$subsMng.subscriptionPlan ? this.$subsMng.subscriptionPlan["nm_subscription_plan"] : "Nenhum plano",
            strChargeInfo: this.strChargeInfo,
            strPaymentMethod: this.strPaymentMethod,
            flCredits: this.flUserCreditsConverted
          }
        ]
      },
      strChargeInfo() {
        if (this.$subsMng.isSubscriptionEmpty) return ""
        if (!this.$subsMng.subscription["bl_activated"]) return ""
        if (!this.$subsMng.subscription["dt_due"]) return ""

        if (includes(this.$subsMng.subscriptionPlan["ab_subscription_plan"], "TRIAL")) return ""
        if (this.$subsMng.subscription["bl_auto_renew"]) return "Renovação automática da assinatura"

        const dtDue = moment(this.$subsMng.subscription["dt_due"], moment.ISO_8601).add(1, 'days')
        const dtNow = moment(new Date(), moment.ISO_8601)
        const remainingDays = dtDue.diff(dtNow, "days")

        if (remainingDays <= 0)
          return "Sua assinatura está vencida"

        return `Válido por ${remainingDays} dia(s)`
      },
      strPaymentMethod() {
        if (this.$subsMng.isSubscriptionEmpty) return ""
        if (!this.$subsMng.subscription["bl_activated"]) return ""
        if (includes(this.$subsMng.subscriptionPlan["ab_subscription_plan"], "TRIAL")) return ""

        switch (this.$subsMng.subscriptionPlan["ab_payable_with"]) {
          case 'ALL':
            return "Cartão de crédito e boleto"
          case 'credit-card':
            return "Cartão de crédito"
          case 'postpay':
            return "Boleto bancário"
          default:
            return ""
        }
      },
      strCreditsDescription() {
        if (this.$appMng.isIntl)
          return "1 crédito corresponde a 1 dólar"
        return "1 crédito corresponde a 1 real"
      },
    },
    created() {
      this.isLoading = true
      const getSubscriptionPromise = this.$subsMng.getSubscription(this.$apiAuth.getAuthToken())

      const getUserCreditsPromise = getUserCredits(this.$apiAuth.getAuthToken())
        .then(res => {
          const userCredits = res.data.data
          this.flUserCreditsConverted = userCredits["int_user_credits"] / 100
        })

      const listUserHectarePackagePromise = listUserHectarePackage(this.$apiAuth.getAuthToken())
        .then((res) => {              
          const userPackages = res.data.data   
          this.packages = userPackages          
        })

      Promise.all([getSubscriptionPromise, getUserCreditsPromise, listUserHectarePackagePromise])
        .finally(() => {
          this.isLoading = false
        })
    }
  }
</script>

<style scoped lang="scss">
</style>
